/* tslint:disable */
/* eslint-disable */
/**
 * Umsatzcontrolling
 * Money
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { RailiumEinsatz } from './RailiumEinsatz';
import {
    RailiumEinsatzFromJSON,
    RailiumEinsatzFromJSONTyped,
    RailiumEinsatzToJSON,
} from './RailiumEinsatz';
import type { RailiumEinsatzDifferenz } from './RailiumEinsatzDifferenz';
import {
    RailiumEinsatzDifferenzFromJSON,
    RailiumEinsatzDifferenzFromJSONTyped,
    RailiumEinsatzDifferenzToJSON,
} from './RailiumEinsatzDifferenz';

/**
 * Historische Zuordnung eines Railium-Einsatzes zu einem Umsatz.
 * @export
 * @interface RailiumEinsatzHistorie
 */
export interface RailiumEinsatzHistorie {
    /**
     * 
     * @type {number}
     * @memberof RailiumEinsatzHistorie
     */
    id: number;
    /**
     * 
     * @type {RailiumEinsatz}
     * @memberof RailiumEinsatzHistorie
     */
    railiumEinsatz: RailiumEinsatz;
    /**
     * 
     * @type {string}
     * @memberof RailiumEinsatzHistorie
     */
    gueltigVon: string;
    /**
     * 
     * @type {string}
     * @memberof RailiumEinsatzHistorie
     */
    gueltigBis: string;
    /**
     * 
     * @type {RailiumEinsatzDifferenz}
     * @memberof RailiumEinsatzHistorie
     */
    differenzZumVorherigen?: RailiumEinsatzDifferenz;
}

/**
 * Check if a given object implements the RailiumEinsatzHistorie interface.
 */
export function instanceOfRailiumEinsatzHistorie(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "railiumEinsatz" in value;
    isInstance = isInstance && "gueltigVon" in value;
    isInstance = isInstance && "gueltigBis" in value;

    return isInstance;
}

export function RailiumEinsatzHistorieFromJSON(json: any): RailiumEinsatzHistorie {
    return RailiumEinsatzHistorieFromJSONTyped(json, false);
}

export function RailiumEinsatzHistorieFromJSONTyped(json: any, ignoreDiscriminator: boolean): RailiumEinsatzHistorie {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'railiumEinsatz': RailiumEinsatzFromJSON(json['railiumEinsatz']),
        'gueltigVon': json['gueltigVon'],
        'gueltigBis': json['gueltigBis'],
        'differenzZumVorherigen': !exists(json, 'differenzZumVorherigen') ? undefined : RailiumEinsatzDifferenzFromJSON(json['differenzZumVorherigen']),
    };
}

export function RailiumEinsatzHistorieToJSON(value?: RailiumEinsatzHistorie | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'railiumEinsatz': RailiumEinsatzToJSON(value.railiumEinsatz),
        'gueltigVon': value.gueltigVon,
        'gueltigBis': value.gueltigBis,
        'differenzZumVorherigen': RailiumEinsatzDifferenzToJSON(value.differenzZumVorherigen),
    };
}

